// target audience for automated communications
export const AUTOMATED_COMMS_TARGETS = {
  SENT_TO_CREATOR: "creator",
  SENT_TO_USERS: "user",
  SENT_TO_AFFILIATES: "affiliate",
};
